var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    color: "#fff",
    viewBox: "0 0 980.5 976.08"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.6 281.29a96.91 96.91 0 00-96.49 88l-130.35 37a189 189 0 00-277.2-77.17l-101.95-98.47a150.34 150.34 0 10-49.46 48.51l102.1 98.6a188.91 188.91 0 0033.9 252.89l-53.84 96.55a126.14 126.14 0 1060.5 33.69l53.68-96.27a188.86 188.86 0 0060.82 10c104.33 0 188.94-84.58 188.94-188.92 0-4.13-.15-8.21-.41-12.27l132-37.48a96.91 96.91 0 1077.82-154.66z"
  })));
}
export default SvgKnowledgeGraph;